<template>
  <v-container class="pt-0 px-0">
    <v-subheader class="text-h5 px-0">Einstellungen</v-subheader>
    
    <v-select class="mt-3" :items="barcodepruefungItems" v-model="settings.barcodepruefung" label="Barcodeprüfung" hint="Genauigkeit des Barcodesscans" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <v-select class="mt-3" :items="taschenlampeItems" v-model="settings.taschenlampe" label="Taschenlampe beim Scannen" hint="Standard beim Start des Kamera-Scanners" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <v-select class="mt-3" :items="keyboardwedgesettings" v-model="settings.keyboardwedgescanner" label="Keyboard-Wedge Scanner" hint="Scanner mit Tastatursimulation (Spezielle Geräte)" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <div class="d-flex mt-3">
        <v-text-field type="number" v-model="settings.avgTimeByChar" label="Durchschnittszeit per Buchstabe" placeholder="60" outlined color="white" persistent-hint suffix="ms"></v-text-field>
        <v-spacer></v-spacer>
        <v-text-field type="number" v-model="settings.timeBeforeScanTest" label="Zeit vor Scantest" placeholder="200" outlined color="white" persistent-hint suffix="ms"></v-text-field>
    </div>
    <v-switch class="mt-3" v-model="settings.sprachausgabe" label="Sprachausgabe bei Einsätzen" color="primary" hide-details></v-switch>
    <v-btn class="mx-0 mt-3" outlined block color="primary" :disabled="!sprachausgabeUnterstuetzt" @click="testSprachausgabe">
        <v-icon left>mdi-volume-high</v-icon>Sprachausgabe testen
    </v-btn>
    <div class="text-caption mt-1" v-if="sprachausgabeHinweis">{{ sprachausgabeHinweis }}</div>

    <v-btn class="mx-0 mt-5 mb3" dark block color="primary" @click="save">Speichern</v-btn>

    <v-subheader class="text-h6 px-0 mt-5">Geräteunterstützung</v-subheader>
    <v-list dense class="py-0">
        <v-list-item v-for="check in geraeteChecks" :key="check.label" class="px-0">
            <v-list-item-icon class="mr-3">
                <v-icon :color="check.unterstuetzt ? 'green' : 'red'">{{ check.unterstuetzt ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ check.label }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>

    <v-textarea auto-grow label="Geräteerkennung" class="mt-3" :value="device" outlined readonly></v-textarea>

    <v-snackbar v-model="snackbar" :color="snackbar_color" timeout="5000" bottom class="snackbar text-center">{{ snackbar_text }}</v-snackbar>
  </v-container>
</template>

<script>


  export default {
    name: 'settings',
    data: () => ({
        settings:{
            barcodepruefung: 2,
            keyboardwedgescanner: "",
            taschenlampe: "last",
            avgTimeByChar: 60,
            timeBeforeScanTest: 200,
            sprachausgabe: true,
        },
        barcodepruefungItems:[
            {val: 1, text: "keine verbesserte Genauigkeit"},
            {val: 2, text: "gering verbesserte Genauigkeit"},
            {val: 3, text: "normale Genauigkeit"},
            {val: 4, text: "hohe Genauigkeit"},
        ],
        taschenlampeItems:[
            {val: "off", text: "Aus"},
            {val: "on", text: "Ein"},
            {val: "last", text: "Wie zuletzt eingestellt"},
        ],
        keyboardwedgesettings:[
            {val: "", text: "Kein Scanner mit Tastatursimulation"},
            {val: "CR", text: "Scanner mit Endezeichen CR"},
            {val: "LF", text: "Scanner mit Endezeichen LF"},
            {val: "CRLF", text: "Scanner mit Endezeichen CR/LF"},
            {val: "Tab", text: "Scanner mit Endezeichen Tab"},
        ],
        sprachausgabeHinweis: "",
        snackbar: false,
        device: false,
        snackbar_color: "success",
        snackbar_text: "Speichern erfolgreich",
    }),
    mounted(){
        var s = localStorage.getItem("settings")
        if (s) this.settings = Object.assign({}, this.settings, JSON.parse(s));
        this.device = window.navigator.userAgent;
    },
    methods: {
        testSprachausgabe(){
            // Der Tipp auf den Button schaltet die Sprachausgabe des Browsers für diese Sitzung frei
            const stimmen = window.speechSynthesis.getVoices().filter(v => /^de/i.test(v.lang));
            this.sprachausgabeHinweis = stimmen.length
                ? "Deutsche Stimme gefunden: " + stimmen[0].name
                : "Keine deutsche Stimme gefunden. Bitte in den Geräteeinstellungen (Sprachausgabe) eine deutsche Stimme installieren.";
            this.$speak("Alarm. Sprachausgabe funktioniert.");
        },
        save(){
            try{
                localStorage.setItem("settings",JSON.stringify(this.settings));
                this.snackbar_color = "success";
                this.snackbar_text = "Speichern erfolgreich";
            }catch(e){
                this.snackbar_color = "danger";
                this.snackbar_text = "Speichern fehlerhaft";
                if (e.message) this.snackbar_text+= ': '+e.message
            }
            this.snackbar = true;
        },
    },
    computed: {
        sprachausgabeUnterstuetzt(){
            return 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
        },
        geraeteChecks(){
            return [
                { label: "NFC", unterstuetzt: 'NDEFReader' in window },
                { label: "GPS", unterstuetzt: 'geolocation' in navigator },
                { label: "Barcodescanner (Kamera)", unterstuetzt: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) },
            ]
        },
    }
  }
</script>
<style scoped>
    .snackbar{
        text-align: center;
    }
    .v-input__slot {
    align-items: right;
    justify-content:end
    }
</style>